import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import moment from 'moment';
import CandidateDatatable from './CandidateDataTable';
import CandidateFilter from './CandidateFilter';

const CandidateIndex = () => {
  const dispatch = useDispatch();
  const [customParams, setCustomParams] = useState({});
  const [defaultStartDate, setDefaultStartDate] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState('0');

  const handleFilterSubmit = values => {
    const hasFilters = Object.values(values).some(val => val);
    if (!hasFilters) {
      setCustomParams({});
      setDefaultStartDate(null);
      return;
    }

    const params = {
      selection_process_id: values.filterSelectionProcessId || '',
      query: values.filterProcessName || '',
      date_from: values.filterDateFrom ? moment(values.filterDateFrom, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
      filter_job_management:
        values.filterJobManagement && values.filterJobManagement !== 'all' ? values.filterJobManagement : '',
      filter_job_title: values.filterJobTitle && values.filterJobTitle !== 'all' ? values.filterJobTitle : ''
    };

    Object.keys(params).forEach(k => {
      if (!params[k]) delete params[k];
    });

    setCustomParams(params);
    setDefaultStartDate(values.filterDateFrom ? moment(values.filterDateFrom) : null);
  };

  const handleClearFilters = () => {
    setCustomParams({});
    setDefaultStartDate(null);
  };

  return (
    <>
      <Row className="mt-4">
        <Col>
          <h2 className="mt-3 mb-1">Historial de Candidatos</h2>
        </Col>
      </Row>
      <Accordion className="my-4" activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-2">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>Filtros de Búsqueda</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>

          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              <CandidateFilter
                dispatch={dispatch}
                formRequest={handleFilterSubmit}
                onClear={handleClearFilters}
                defaultStartDate={defaultStartDate}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <div className="data-table-yellow">
        <CandidateDatatable customParams={customParams} />
      </div>
    </>
  );
};

export default CandidateIndex;
